import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, firstValueFrom } from "rxjs";

import { CotizacionesService } from "src/app/pages/cotizaciones/services/cotizaciones.service";
import { AuthService } from "./auth.service";

@Injectable({ providedIn: "root" })
export class CartCountService {
  private cotizaciones = inject(CotizacionesService);
  private auth = inject(AuthService);

  private _count = new BehaviorSubject<number>(0);
  readonly count$ = this._count.asObservable();

  get snapshot(): number {
    return this._count.value;
  }

  setCount(n: number): void {
    this._count.next(n);
  }

  reset(): void {
    this._count.next(0);
  }

  /** Load the current draft from the API and update the count.
   *  No-ops silently if the user is not logged in. */
  async refresh(): Promise<void> {
    if (!this.auth.isLoggedIn()) return;
    try {
      const res = await firstValueFrom(this.cotizaciones.list(1, 50));
      const draft = this.cotizaciones.findDraft(res.items ?? []);
      const count = (draft?.items ?? []).reduce(
        (acc, it) => acc + (Number(it?.qty) || 0),
        0,
      );
      this._count.next(count);
    } catch {
      /* silent – topbar should not break if API is unreachable */
    }
  }
}
